export const SEND_RECOVERY_PASSWORD_EMAIL_INIT =
  'SEND_RECOVERY_PASSWORD_EMAIL_INIT';
export const SEND_RECOVERY_PASSWORD_EMAIL_SUCCESS =
  'SEND_RECOVERY_PASSWORD_EMAIL_SUCCESS';
export const SEND_RECOVERY_PASSWORD_EMAIL_ERROR =
  'SEND_RECOVERY_PASSWORD_EMAIL_ERROR';

export const SHOW_MODAL_PASSWORD = 'SHOW_MODAL_PASSWORD';
export const HIDE_MODAL_PASSWORD = 'HIDE_MODAL_PASSWORD';

export const SHOW_NEW_PASSWORD_FORM = 'SHOW_NEW_PASSWORD_FORM';

export const SUCCESS_PASSWORD_CHANGED = 'SUCCESS_PASSWORD_CHANGED';
export const CLEAR_RESET_PASSWORD_DATA = 'CLEAR_RESET_PASSWORD_DATA';
